export enum IdkEndpoints {
    CSRF_TOKEN = 'csrf_token',
    USER = '/user',
    ACTIVITY_TYPE = '128',
}

export enum LayoutType {
    SHOWROOM = 'showroom',
    STANDALONE = 'standalone',
}

export enum PromotionType {
    LOCAL = 'local',
    NATIONAL = 'national',
}

export enum RequestStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    SUCCEEDED = 'succeeded',
    FAILED = 'failed',
}

export enum Global {
    ERROR_422 = 422,
    ERROR_404 = 404,
    MINiMUM_FORM_FIELD_LENGTH = 2,
    CYCLE_ID_LENGTH = 12,
}

export enum Params {
    ACTIVITY_TYPE = 'activityType',
    API_TOKEN = 'api-token',
    BEARER = 'bearer',
    BRAND = 'brand',
    CLEANED_COMPANY = 'cleanedCompany',
    COMPANY_CODE = 'companyCode',
    CONTRACT_TYPE = 'contractType',
    DEALER = 'dealer',
    DEALERS = 'dealers',
    ORDER_BY = 'orderby',
    PROVINCES = 'provinces',
    SHOW_FORM = 'showForm-app',
    PROMOTION = 'promo-app',
    QUOTATIONS = 'quotations',
    CAMPAIGN = 'campaign',
    CAMPAIGN_ID = 'campaignID',
    AUTONOMESPOTIFY = 'VolkDealerAUTONOMESPOTIFY',
    AUTONOMEDEM = 'VolkDealerAUTONOMEDEM',
    AUTONOMEPMAX = 'VolkDealerAUTONOMEPMAX',
    PDSSFDW = 'PDSSFDW',
    PCRXXDW = 'PCRXXDW',
    PDSPXDW = 'PDSPXDW',
    CATEGORIES = 'categories',
    FUELS = 'fuels',
    MODELS = 'models',
    NAMES = 'names',
}
